exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n  Responsive helper\n */\n.language[data-v-2e2d94e6]::after {\n  border-color: #ffffff;\n}\n.language select[data-v-2e2d94e6] {\n  background-color: transparent;\n  color: #ffffff;\n  width: 100%;\n}", ""]);

// exports
